import { ElementRef } from '@angular/core';

/**
 * Assigns visibility '' and position '' to elementRef
 * @param el {ElementRef}
 */
export const showElementVisibility = (el: ElementRef) =>
  Object.assign(el.nativeElement.style, { visibility: '', position: '' });

/**
 * assigns visibility hidden and position fixed to elementRef
 * (so element is hidden but not destroyed)
 * @param el {ElementRef}
 */
export const hideElementVisibility = (el: ElementRef) =>
  Object.assign(el.nativeElement.style, { visibility: 'hidden', position: 'fixed' });
